// extracted by mini-css-extract-plugin
module.exports = {"DayCell":"DayCell_DayCell__2PUnb","HighTemp":"DayCell_HighTemp__2e9h-","FeelsLike":"DayCell_FeelsLike__1G9VL"};